export enum EUnitControlType {
  RADAROPEN = 'radaropen',
  RADARCLOSE = 'radarclose',
  TIMEBEGIN = 'timebegin',
  TIMEEND = 'timeend',
  timewithT = 'timewithT',
  card = 'card',
  netlost='netlost',
  co2danger='co2danger',
  rain='rain',
  ODpm205='ODpm2.5',
  ODhumidity='ODhumidity',
  ODcold='ODcold',
  envcheck='envcheck',
  weather='weather',
  pm2o5='pm2.5',
  voc='voc',
  co2='co2',
  airopen='airopen',
  time='time',

  KEY = 'key',
  APP = 'app',
  GATEWAYMESH='gatewaymesh',
   SCENECTL='scenectl',
  REBOOT = 'reboot',
  airopenctl = 'airopenctl',
  appall = 'appall',
  auto = 'auto',
  co2ctl = 'co2ctl',
  compel = 'compel',
  delayclose = 'delayclose',
  envcheck = 'envcheck',
  pm2o5ctl = 'pm2o5ctl',
  radarwithL = 'radarwithL',
  radarwithT = 'radarwithT',
  weatherctl = 'weatherctl',
  vocctl = 'vocctl',
  envcheckweather = 'envcheckweather',
  envcheckpm2o5 = 'envcheckpm2o5',
  envcheckvoc = 'envcheckvoc',
  envcheckco2 = 'envcheckco2',
  envcheckairopen = 'envcheckairopen',
  cool='cool',
  hot='hot',
  null='null',
  win='win',
  autosz='autosz',
  dry='dry',
  close='close',
  meshcheckreboot='meshcheckreboot',
  heartbeatreboot='heartbeatreboot',
  cLightbysomeone='cLightbysomeone',
  cLightbynoone='cLightbynoone',
  cLightbytime='cLightbytime',
  voicectl='voicectl',
  magnet='magnet',
  timeendrdop='timeendrdop',
  toobright='toobright',
  rebootrecover='rebootrecover',
  low='low',
  high='high',
  mid='mid',
}
export const UnitControlTypeMap = new Map<EUnitControlType, string>([
  [EUnitControlType.toobright, '过亮控制'],
  [EUnitControlType.timeendrdop, '定时结束雷达控制'],
  [EUnitControlType.RADARCLOSE, '雷达无人控制'],
  [EUnitControlType.RADAROPEN, '雷达有人控制'],
  [EUnitControlType.TIMEBEGIN, '定时控制'],
  [EUnitControlType.TIMEEND, '定时控制'],
  [EUnitControlType.KEY, '按键控制'],
  [EUnitControlType.APP, 'APP控制'],
  [EUnitControlType.rebootrecover, '重启恢复'],
  [EUnitControlType.SCENECTL, '情景模式控制'],
  [EUnitControlType.cool, '制冷'],
  [EUnitControlType.card, '卡'],
  [EUnitControlType.voicectl, '语音控制'],
  [EUnitControlType.netlost, '断网自动控制'],
  [EUnitControlType.co2danger, '二氧化碳危险'],
  [EUnitControlType.rain, '雨'],
  [EUnitControlType.ODpm205, '室外pm2.5'],
  [EUnitControlType.magnet, '磁感控制'],
  [EUnitControlType.ODhumidity, '室外湿度'],
  [EUnitControlType.ODcold, '室外寒冷'],
  [EUnitControlType.envcheck, '环境检查'],
  [EUnitControlType.weather, '天气'],
  [EUnitControlType.pm2o5, 'pm2.5'],
  [EUnitControlType.voc, 'VOC'],
  [EUnitControlType.co2, '二氧化碳'],
  [EUnitControlType.airopen, '空调开'],
  [EUnitControlType.time, '定时'],


  [EUnitControlType.win, '送风'],
  [EUnitControlType.hot, '制热'],
  [EUnitControlType.null, '关闭'],
  [EUnitControlType.close, '关闭'],
  [EUnitControlType.autosz, '自动'],
  [EUnitControlType.dry, '除湿'],
  [EUnitControlType.GATEWAYMESH, '网关重启保留上次'],
  [EUnitControlType.meshcheckreboot, 'mesh检查'],
  [EUnitControlType.heartbeatreboot, '心跳重启'],
  [EUnitControlType.cLightbysomeone, '有人恒光'],
  [EUnitControlType.cLightbynoone, '无人恒光'],
  [EUnitControlType.cLightbytime, '定时恒光'],
  [EUnitControlType.REBOOT, '设备重启'],
  [EUnitControlType.timewithT, '定时且温度满足'],

  

  [EUnitControlType.airopenctl, '空调开'],
  [EUnitControlType.appall, 'app批量控制'],
  [EUnitControlType.auto, '空调温度被锁，跳回原来温度'],
  [EUnitControlType.co2ctl, '二氧化碳条件满足'],
  [EUnitControlType.compel, '空调温度强制开关'],
  [EUnitControlType.delayclose, '延时关闭'],
  [EUnitControlType.envcheck, '空气策略补充检查'],
  [EUnitControlType.pm2o5ctl, 'pm2.5条件满足'],
  [EUnitControlType.radarwithL, '光照满足条件'],
  [EUnitControlType.radarwithT, '温度满足条件'],
  [EUnitControlType.weatherctl, '天气条件满足'],
  [EUnitControlType.vocctl, 'VOC条件满足'],
  [EUnitControlType.envcheckweather, '天气检查'],
  [EUnitControlType.envcheckpm2o5, 'pm2.5检查'],
  [EUnitControlType.envcheckvoc, 'voc检查'],
  [EUnitControlType.envcheckco2, 'co2检查'],
  [EUnitControlType.envcheckairopen, '空调开状态检查'],
  [EUnitControlType.low, '低风'],
  [EUnitControlType.high, '高风'],
  [EUnitControlType.mid, '中风'],
])

export enum EDateUnitType {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}
export const DateUnitTypeMap = new Map<EDateUnitType, string>([
  [EDateUnitType.DAY, '日'],
  [EDateUnitType.MONTH, '月'],
  // [EDateUnitType.YEAR, '年'],
])

export enum SingleType {
  SINGLE = 'single',
  ALL = 'all',
}
export const SingleTypeMap = new Map<SingleType, string>([
  [SingleType.SINGLE, '单个'],
  [SingleType.ALL, '全部'],
])

export enum EDevType {
  AIR = 'air',
  OTHER = 'other',
  SWITCH = 'switch',
}
export const DevTypeMap = new Map<EDevType, string>([
  [EDevType.AIR, '空调'],
  [EDevType.SWITCH, '灯光'],
  [EDevType.OTHER, '其他'],
])

export enum ERegoinLevel {
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  Four = 4,
}
export const StatsUnitTypeMap = new Map<ERegoinLevel, string>([
  [ERegoinLevel.ZERO, '楼'],
  [ERegoinLevel.ONE, '层'],
  [ERegoinLevel.TWO, '区'],
  [ERegoinLevel.THREE, '部门'],
])

export enum EStatsRunTimeUnit {
  /** 累计时间 */
  ADDTIME = 'addTime',
  /** 平均时间 */
  AVGTIME = 'avgTime',
  /** 新增时间 */
  SUMTIME = 'sumTime',
}
export const StatsRuntimeUnitTabsMap = new Map<EStatsRunTimeUnit, string>([
  [EStatsRunTimeUnit.ADDTIME, '累计时间'],
  [EStatsRunTimeUnit.SUMTIME, '新增时间'],
  [EStatsRunTimeUnit.AVGTIME, '平均时间'],
])

export enum EStatsEnergyUnit {
  /** 累计电量 */
  ADDTIME = 'ope',
  /** 新增时间 */
  SUMTIME = 'addTime',
}

export const StatsEnergyTabsMap = new Map<EStatsEnergyUnit, string>([
  [EStatsEnergyUnit.ADDTIME, '累计电量'],
  [EStatsEnergyUnit.SUMTIME, '新增电量'],
])

export enum EStatsLocalUnit {
  POSITION = 1,
  DEPARTMENT = 2
}
export const StatsLocalUnitMap = new Map<EStatsLocalUnit, string>([
  [EStatsLocalUnit.POSITION, '按位置'],
  [EStatsLocalUnit.DEPARTMENT, '按部门'],
])
